export const BLOG_CATEGORIES: {
  title: string;
  slug: "news" | "education";
  description: string;
}[] = [
  {
    title: "news",
    slug: "news",
    description: "Updates and announcements from AI-HeadShot.net",
  },
  {
    title: "education",
    slug: "education",
    description: "Educational content about AI-HeadShot.net",
  },
];

export const BLOG_AUTHORS = {
  UllrAI: {
    name: "UllrAI",
    image: "/_static/avatars/ullrai.svg",
    twitter: "Ullr_AI",
  },
};
